import React from "react"

import ViewFormActionButtonsWidget from "../../../common/ViewFormActionButtonsWidget"
import WidgetHeaderButton from "../../../common/WidgetHeaderButton"

const InsightAreaViewFormActionButtonsWidget = props => {
    const { onTopicSync, canSync, isFetching, activeId } = props

    return (
        <ViewFormActionButtonsWidget {...props}>
            <WidgetHeaderButton
                onClick={() => onTopicSync(activeId)}
                disabled={isFetching || !canSync}
            >
                Sync with Salesforce
            </WidgetHeaderButton>
        </ViewFormActionButtonsWidget>
    )
}

export default InsightAreaViewFormActionButtonsWidget
